import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutNote, checkoutUrl, offer, primaryCta } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-71" data-mp="19fqljqoyjhcm">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-72" data-mp="15dlt2va8wqrk">
        <div className="mx-auto max-w-lg rounded-xl bg-white p-8 text-center shadow-lg ring-2 ring-blue-600" data-id="element-73" data-mp="15c2gpfrpmzv2">
          <h3 className="text-lg font-extrabold uppercase leading-snug tracking-tight text-gray-900" data-id="element-74" data-mp="1jasbgor24ng9">
            {offer.name}
          </h3>
          <p className="mt-2 text-gray-600" data-id="element-75" data-mp="1t37ulpe3bi2q">6 Tomos + 5 Bonos Profesionales</p>
          <p className="mt-6" data-id="element-76" data-mp="1o43ml22wjqdz">
            <span className="block text-base text-gray-400 line-through" data-id="element-77" data-mp="1o4wkddjvv5jz">{offer.listPrice}</span>
            <span className="text-4xl font-extrabold tracking-tight text-gray-900 md:text-5xl" data-id="element-78" data-mp="224o2nqhfn83s">
              {offer.price}
              <span className="ml-2 text-lg font-semibold text-gray-500" data-id="element-79" data-mp="1x6cudk6sd5no">ARS</span>
            </span>
          </p>
          <div className="mt-7" data-id="element-80" data-mp="n7p8dklnnnmy">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-81" data-mp="s45t04tnbjva">
              {primaryCta}
            </CtaButton>
            <p className="mt-3 text-sm text-gray-500" data-id="element-82" data-mp="x2qtm5ct85k9">{checkoutNote}</p>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-gray-600" data-id="element-83" data-mp="12354dv5sptlz">
            <li className="inline-flex items-center gap-1.5" data-id="element-84" data-mp="163xesrqem4ju">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-85" data-mp="1b31l9aly1o6h" /> Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="1fu04ahybh0df">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-87" data-mp="1fwme6o8ojryt" /> Acceso inmediato
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-88" data-mp="1psfu8hlly3lc">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-89" data-mp="1puakmbfnenwt" /> Garantía
              de 7 días
            </li>
          </ul>
        </div>

        <div className="mx-auto mt-14 max-w-2xl text-center" data-id="element-90" data-mp="3qtvuq5r6uqcj">
          <p className="text-lg font-semibold text-gray-600 md:text-xl" data-id="element-91" data-mp="3lvkos640kzzl">Deja de preguntarte:</p>
          <p className="mt-2 text-2xl font-extrabold italic leading-snug tracking-tight text-gray-900 md:text-4xl" data-id="element-92" data-mp="3hl5z8jysgd5">
            “¿Cuál de estas pinzas era?”
          </p>
          <p className="mt-4 text-2xl font-extrabold leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-93" data-mp="3uuzc4wovwufv">
            Mira el detalle. Reconoce la diferencia.
          </p>
        </div>
      </div>
    </section>;
}